import { render, staticRenderFns } from "./V2OrderProductsFilter.vue?vue&type=template&id=3bbbc7aa&scoped=true&"
import script from "./V2OrderProductsFilter.vue?vue&type=script&lang=js&"
export * from "./V2OrderProductsFilter.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderProductsFilter.vue?vue&type=style&index=0&id=3bbbc7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbbc7aa",
  null
  
)

export default component.exports